import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Utility, { removeDelayedLoader, showDelayedLoader } from "../../../utility/Utility";
import { deepClone } from "../../../utility/Utility"
import {
  DKLabel,
  DKButton,
  DKDataGrid,
  DKCalendar,
  Toggle,
  showAlert,
  DKIcons,
  showLoader,
  removeLoader,
  DKListPicker,
  showToast,
  TOAST_TYPE,
  DKInput,
  DKSearchBar,
  DKTooltipWrapper,
  DKIcon,
  DKSpinner
} from "deskera-ui-library";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import { parseColumnConfig, teamAttendanceColumnConfig, AttendanceDrillDownColumnConfig, AttendanceDrillDownColumnName, parseVisibleColumnConfig, getFileName } from "../../configs/config";
import { selectTeamAttendanceColumnConfig } from "../../../Redux/Slices/TeamAttendanceSlice";
import AttendanceService, { defaultDashboardTeamConfig, defaultTeamConfig } from "../../../services/AttendanceService";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../../managers/TableManger";
import moment from 'moment'
import { ATTENDANCE_TYPE, DASHBOARD_TEAM_ATTENDANCE, FILE_TYPE, FORMAT, FORM_ACTIONS, INPUT_TYPE } from "../../../constants/Constant";
import calender from '../../../assets/icons/white/date_range.svg'
import funnel from '../../../assets/menu/white/ic_funnel.png'
import ApiConstants from "../../../constants/ApiConstants";
import { useTranslation } from "react-i18next";
import Table from "../../../services/table";
import Popup from "../../common/Popup";
import ShiftManagementService from "../../../services/ShiftManagementService";
import EmployeeListService from "../../../services/EmployeeListService";
import i18next from "i18next";
import { isProfessionalPlan, isWeekFilterEnable } from "../../../managers/common/CommonUtil";
import SideBarService from "../../../services/sidebar";
import { BiometricDetailsSelector, fetchBiometricDetails } from "../../../Redux/Slices/BiometricSlice";

import { saveAs } from 'file-saver';
import { TENANT, TenantService } from "./../../../managers/TenantManagerService";
import AttachmentService from "../../../services/AttachmentService";
import { isMobileWebView } from "../../../utility/ViewportSizeUtils";
import { fetchTeamAttendanceDashbaord, selectTeamAttendanceDashbaord } from "../../../Redux/Slices/TeamAttendanceDashboardSlice";
let searchTimer;

const TeamAttendanceCard = (props) => {
    const { t, i18n } = useTranslation();

    const initialState = {
        columnData: [],
        rowData: [],
        originalData: [],
        filter: ''
    };
    //State hooks
    const [refresh, setRefresh] = useState(false);
    const [attendance, setTeamAttendance] = useState(initialState);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalCount, setTotalCount] = useState(10);
    const [designations,setDesignations] = useState([]);
    const [shifts, setShifts] = useState([]);
    const [hideTerminated, setHideTerminated] = useState(false);
    const [showAttendancePopup, setShowAttendancePopup] = useState(false);
    const [attendancePopupData, setAttendancePopupData] = useState({});
    const [selectedAttendance, setSelectedAttendance] = useState({});
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [confirmationPopupData, setConfirmationPopupData] = useState({});
    const [width, setWidth] = useState(SideBarService.getContainerWidth())
    const [punchingError,setPunchingError] = useState(null);
    const [gridWidth, setGridWidth] = useState(466);
    const [showSpinner, setSpinner] = useState(false);
    const [isPageLoader, setIsPageLoader] = useState(false);
    
    const gridContainer = useRef();
    const initialYear = {
        toggle: false,
        startDate: moment(),
        endDate: moment()
    }
    const [selectYear,setYear] = useState(initialYear)
    //Store data selectors
    const dispatch = useDispatch();

    const attendanceData = useSelector(selectTeamAttendanceDashbaord);
    const columnConfig = useSelector(selectTeamAttendanceColumnConfig);
    const isActionEnabled = false;
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [selectedUserDetails, setSelectedUserDetails] = useState(null);
    const [filterWeek, setFilterWeek] = useState({
      year: new Date().getFullYear(),
      start: '',
      end:'',
      displayText:''
    })
    const [selectedDuration, setSelectedDuration] = useState('Week')
    const [selectedRow, setSelectedRow] = useState([]);
    var counterForFilter = 0;
    const [editData, setEditData] = useState();

    const biometricDetail = useSelector(BiometricDetailsSelector);
    const [showBiometricSync, setShowBiometricSync] = useState(false);
    const [filterPopup, setFilterPopup] = useState({value:'All'})
    useEffect(() => {
      window.addEventListener("resize", windowSizeUpdated);
      window.addEventListener('onSideBarChange', windowSizeUpdated);
        
        /* API Calls Start */
        if(!isWeekFilterEnable()) {
          loadAttendance({
              ...defaultDashboardTeamConfig,
              Limit:5
          });
        } else {
          getSelectedDuration();
        }
        fetchDependancies();
        window.openSelectedLocation = function (latitude, longitude) {
          const link = ApiConstants.URL.GEO_LOCATION.VIEW_LOCATION(latitude, longitude);
          window.open(link, "_blank", "noopener");
        };
        /* API Calls End */
        return () => {
            window.removeEventListener("resize", windowSizeUpdated);
            window.removeEventListener('onSideBarChange', windowSizeUpdated);
            window.openSelectedLocation = () => {};
            setTeamAttendance(initialState)};
            
              
    }, [])

    useEffect(() => {
        if (!Utility.isEmpty(attendanceData)) {
            setGridWidth(gridContainer?.current?.clientWidth || 1000);
            const { attendances, filterConfig } = attendanceData;
            const rowData = teamAttendanceColumnConfig(attendances, getExpandableView, 'employeeId');
            const attendanceColumn = (parseVisibleColumnConfig(parseColumnConfig(changeShiftColumnPosition(DASHBOARD_TEAM_ATTENDANCE),TABLES.TEAM_ATTENDANCE,{isCardView:true})));
            const passingData = {
                columnData: deepClone(attendanceColumn),
                rowData,
                filter: AttendanceService.apiDashboardTeamConfig['filter'],
                originalData: rowData
            };
            setTeamAttendance(passingData);
            setTotalPageCount(parseInt(filterConfig.totalPage));
            setCurrentPage(parseInt(filterConfig.page)+1);
            if(AttendanceService.apiDashboardTeamConfig['searchField']){
                setCurrentPage(parseInt(filterConfig.page));
            }
            setTotalCount(parseInt(filterConfig.numberOfRecords))
        } else {
            const attendanceColumn = (parseVisibleColumnConfig(parseColumnConfig(changeShiftColumnPosition(DASHBOARD_TEAM_ATTENDANCE),TABLES.TEAM_ATTENDANCE,{isCardView:true})));
            const passingData = {
                columnData: deepClone(attendanceColumn),
                rowData:[],
                filter: '',
                originalData: []
            }
            setGridWidth(gridContainer?.current?.clientWidth || 1000);
            setTeamAttendance(passingData);
        }
        if(AttendanceService.apiDashboardTeamConfig['filter']){
            const config = {
                ...AttendanceService.apiDashboardTeamConfig,
                searchString:"",
                searchField:""
            };
            AttendanceService.apiDashboardTeamConfig = config;
            setHideTerminated(false);
        }
    }, [attendanceData]);

    useEffect(() => {
        if (!Utility.isEmpty(biometricDetail?.details)) {
            setShowBiometricSync(true);
        }
    }, [biometricDetail]);

    const changeShiftColumnPosition = (columns) => {
        if (columns) {
            const shiftColumn = columns.find(c => c.columnCode === COLUMN_CODE.ATTENDANCE_TEAM.SHIFT);
            if (shiftColumn) {
                const shiftIndex = columns.findIndex((c) => c.columnCode === COLUMN_CODE.ATTENDANCE_TEAM.SHIFT);
                columns.splice(shiftIndex, 1);
                columns.splice(3, 0, shiftColumn);
            }
        }
        return columns;
    }

    const loadAttendance = async (config,isPaging) => {
        try {
            if(isPaging) {
              setIsPageLoader(true)
            } else {
              setSpinner(true)
            }
            AttendanceService.apiDashboardTeamConfig = {...config};
            await dispatch(fetchTeamAttendanceDashbaord());            
            
            if(isPaging) {
              setIsPageLoader(false)
            } else {
              setSpinner(false)
            }
        } catch (err) {
            console.error('Error loading contacts: ', err);
        }
    };

    const fetchDependancies = async () => {
        const dependancy = await Promise.all([AttendanceService.getDesignation(), ShiftManagementService.getShifts(false)]);
        setDesignations(dependancy[0]);
        const filteredshifts = dependancy[1]?.data?.filter((shift) => shift.employees?.length > 0);
        setShifts(filteredshifts);

        if (isProfessionalPlan()) {
            dispatch(fetchBiometricDetails());
        }
    }
    
    const onDeleteContact = (data) => {
        const attendanceId = data[0].id;
    };

    const onRowEdit = (data) => {
      setEditData(data.rowData.data);
      onClockEntry(data, "CLOCK_OUT", true)
    };

    const onSearch = (search) => {
        if (!search || search?.length >= 3) {
            clearTimeout(searchTimer);
            searchTimer = setTimeout(() => {
                const config = {
                    ...AttendanceService.apiDashboardTeamConfig,
                    page: 0,
                    search: search
                };
                loadAttendance(config,true);
            }, 500);
        }
    };
    const newColumnAdded = (data) => {
        const columns = attendance.columnData;
        columns.push(data);
        setTeamAttendance({ ...attendance, columnData: columns });
    };

    const onFilter = (updatedList, queries) => {
    };

    const onRowAdd = (newRow) => {
    };
    
    const onSubRowClick = (rowIndex, rowData) => {
      
  };
  const getFunctionConfig = () => {
    let config = {
      "punchIn": punchIn,
      "punchOut": punchOut
    };
    return config;
  }
  const punchIn = (data) =>{
    console.log(data)
  }
  const punchOut = (data) =>{
    console.log(data)
  }
    const getExpandableView = (rowData) => {
        if (rowData.punchingLogs != null && rowData.punchingLogs.length > 0) {
          const functionConfig = getFunctionConfig();
            const rows = AttendanceDrillDownColumnConfig(rowData.punchingLogs,functionConfig,rowData);
            const columns = [];
            Object.values(COLUMN_CODE.ATTENDANCE_DRILL_DOWN).forEach(value => {
                columns.push({name: AttendanceDrillDownColumnName(value), key: value, type:'text', width:310});
            });
            let modifyColumns = [
              {
                key: 'actions',
                name: "Action",
                className:'p-0',
                type: INPUT_TYPE.BUTTON,
                width: 100,
                options:[{
                  title: "Edit",
                  className:'p-0 text-app fw-m text-underline',
                  onClick: (data) => {
                      let obj = {
                        ...data,
                        rowIndex:data.rowIndex
                      }
                      setEditData(data.rowData.data)
                      if(data.rowData.type == 'Exit') {
                        onClockEntry(obj, "CLOCK_OUT", true,true)
                      } else {
                        onClockEntry(obj, "CLOCK_IN", true,true)
                      }
                  }
              }]
            }, 
            ...columns
          ];
          if(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED)) {
            modifyColumns = [...modifyColumns,{
              key: 'attachments',
              name: "Attachments",
              className: 'p-0',
              type: INPUT_TYPE.TEXT,
              width: 250,
              systemField: true,
              editable: false,
              hidden: !TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED),
              uiVisible: true,
              renderer: (data) => {
                return <div className="pt-s">{attachmentColumnData(data.rowData.attachments)}</div>;
              }
            }]
          }
            return (
              <div className="bg-gray2 parent-width" >
                <DKDataGrid
                    allowBulkOperation={false}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowRowEdit={false}
                    allowExpand={false}
                    allowDataExport={false}
                    isActionEnabled={false}
                    onRowOpenBtnHidden={true}
                    isHeaderHidden={true}
                    columns={modifyColumns}
                    rows={rows}
                    onRowClick={onSubRowClick}
                    needTrailingColumn={true}
                    width={width}
                     />
              </div>
            );
        } else {
            return (
                <div
                  className="p-h-xxl bg-gray1 parent-width column align-items-center justify-content-center"
                  style={{ height: 30 }}
                >
                  <DKLabel text="No data available" className="mt-r fs-m" />
                </div>
              );
        }
    }
    const windowSizeUpdated = () => {
      setWidth(SideBarService.getContainerWidth())
  };

  const attachmentColumnData = (value) => {
    if (value && value[0]) {
      return value.map(v => { return (<DKTooltipWrapper content={getFileName(v)} tooltipClassName="warning-tooltip-prop"><div onClick={() => downloadDocument(v)} className={"row"} ><img className={"cursor-hand"} style={{ width: 18 }} src={Utility.getFileIcon(getFileName(v))} /></div></DKTooltipWrapper>) })
    } else {
      return '-'
    }
  }
    const updateRowExpanded = data => {
        let {rowIndex, rowData} = data;
        const updatedAttendance = {...attendance};
        updatedAttendance.rowData[rowIndex] = {...rowData};
        setTeamAttendance(updatedAttendance);
    }

    const onClockEntry = (data, type,isEdit,isFromPunchlog) => {
      EmployeeListService.getUserDetailsByIamUserId(data?.rowData?.data?.iamUserId).then(
        res=>{
          if(res.status=="OK") {
            setSelectedUserDetails(res.user)
            
          }
        }
      ).catch(error=>{
        setSelectedUserDetails(true)
        
      })
      const today = moment(new Date()).startOf('day');
      const selectedDate = moment(selectYear.startDate, FORMAT.YYYYMMDD).startOf("day");
      if (selectedDate.isAfter(today)) {
        showAlert(t("PROXY_ATTENDANCE_FUTURE_ERROR"), "");
        return;
      }
      let attendanceDetails = isFromPunchlog ? deepClone(data.rowData.data) :deepClone(attendanceData.attendances[data.rowIndex]);
      if (type === ATTENDANCE_TYPE.CLOCK_OUT && !attendanceDetails.clockIn && !isFromPunchlog) {
        showAlert(t("CLOCK_IN_FIRST_ERROR"), "");
        return;
      }

      attendanceDetails['allowProxyPunch'] =  attendanceDetails?.punchingLogs?.length !=0 ? true: false
      setSelectedAttendance(attendanceDetails);
      const clockInAction =( attendanceDetails.clockIn && isEdit) ? FORM_ACTIONS.EDIT : FORM_ACTIONS.ADD;
      const clockOutAction = (attendanceDetails.clockOut && isEdit)? FORM_ACTIONS.EDIT : FORM_ACTIONS.ADD;
      setAttendancePopupData({
        action:
          isEdit ? isEdit: (type === ATTENDANCE_TYPE.CLOCK_IN ? clockInAction : clockOutAction),
        type,
        date: moment(selectYear.startDate).format(FORMAT.DDMMYYYY),
        employeeName: isFromPunchlog ? data?.rowData?.parentRowData?.data?.employeeName : attendanceDetails.employeeName,
        iamUserId: attendanceDetails.iamUserId,
        clockIn: isFromPunchlog? attendanceDetails.punchAt : attendanceDetails.clockIn,
        clockOut: isFromPunchlog? attendanceDetails.punchAt : attendanceDetails.clockOut,
        attachments: isFromPunchlog? attendanceDetails.attachments :[],
        isuserDetailsLoaded:false,
        isEdit: isEdit,
        isFromPunchlog: isFromPunchlog,
        id:   isFromPunchlog ? data?.rowData?.data?.id: data?.id,
        allowProxyPunch: !isEdit,
        remark: data?.rowData?.remark,
        parentRowData: data?.rowData?.parentRowData
      });
      setShowAttendancePopup(true);
    };

  const downloadDocument = (path) => {
    setSpinner(true)
    
    AttachmentService.getPresignedURL(path).then(
        (response) => {
            AttachmentService.downloadFile(response).then(
                (response) => {
                    
                    setSpinner(false)
                    saveAs(response, getFileName(path));
                },
                (error) => {
                    setSpinner(false)
                    
                }
            );
        },
        (error) => {
            
            setSpinner(false)
            showToast("Something went wrong", TOAST_TYPE.FAILURE);
        }
    );
  }

    const callAddAttendance = (punchTime, remark, isClockIn,dataParam) => {
      setShowConfirmationPopup(false);
      let clockIn =
        attendancePopupData.clockIn != null
          ? moment(attendancePopupData.clockIn).format(FORMAT.YYYYMMDD_HHMM)
          : punchTime;
      if (
        (attendancePopupData.action === FORM_ACTIONS.EDIT &&
        attendancePopupData.type === ATTENDANCE_TYPE.CLOCK_IN) || isClockIn
      ) {
        clockIn = punchTime;
      }
      let params = {
        punchAt: punchTime,
        clockIn,
        type: attendancePopupData.type,
        remark: remark,
        iamUserId: attendancePopupData.iamUserId,
        allowProxyPunch:attendancePopupData.allowProxyPunch,
        ...dataParam
      };
      if(TenantService.get(TENANT.IS_ATTENDANCE_ATTACHMENT_ENABLED)) {
        params = {
          ...params,
          ...dataParam
        }
      }
    
    setSpinner(true)
      Table.proxyAttendance(params).then(
        (response) => {
        
        setSpinner(false)
          setShowAttendancePopup(false);
          setPunchingError(null)
          loadAttendance({ ...AttendanceService.apiDashboardTeamConfig });
        },
        (error) => {
          showToast("Internal Server Error", TOAST_TYPE.FAILURE);
          setSpinner(false)
        
        }
      );
    };

    const getQueryString = (start,end) => {
        const config = AttendanceService.apiDashboardTeamConfig;
        let query = '';
        
        const isAfter = moment().isAfter(moment(start),'date');
        const isBefore = moment().isBefore(moment(start),'date');

        let format = 'YYYY-MM-DD 00:00';
        if(isBefore) {
          format = 'YYYY-MM-DD 00:00'
        } else if(isAfter) {
          format = 'YYYY-MM-DD 23:59'
        } else {
          format = `YYYY-MM-DD ${moment().format('HH:mm')}`
        }
        if(isWeekFilterEnable()) {
          query = `clockIn=${moment(moment(start).format()).format(format)}`;
        } else {
          query = `clockIn=${moment(moment(start).format()).format(format)}`;
        }
        
        if (config.shift) {
            return `${query},shift_id=!${config.shift}`;
        } else {
            return query;
        }
    }
    const getSelectedDuration=(year)=> {
      let duration = {
        ...filterWeek
      }
      if(year) {
        duration['year'] = year;
      }
      if(filterWeek['start'] == '') {
          duration['start'] = moment().format()
      } else {
          let date = moment(duration['start']).format('DD/MM/');
          date += duration['year']
          duration['start'] = moment(date,'DD/MM/YYYY').format()
      }
      switch(selectedDuration) {
          
          case 'Week':
          let startWeekDate = duration['start'];
          let startWeek = moment(startWeekDate).startOf('week').add('d',1).add('week',counterForFilter)
          if(startWeek.format('YYYY') == moment().format('YYYY') || startWeek.format('YYYY') == moment().subtract('year',1).format('YYYY')) {
              duration['start'] = startWeek.format();
              duration['end'] = moment(startWeekDate).endOf('week').add('d',1).add('week',counterForFilter).format();
              duration['displayText'] = moment(startWeekDate).startOf('week').add('d',1).add('week',counterForFilter).format('Do MMM') + ' - ' +moment(startWeekDate).endOf('week').add('d',1).add('week',counterForFilter).format('Do MMM');
              duration['year'] = startWeek.format('YYYY');
          } else {
            showToast("Please choose the appropriate year and month.",TOAST_TYPE.FAILURE)
          }
          break;
      }
      const config = {
        ...AttendanceService.apiDashboardTeamConfig,
        page: 0,
        query: getQueryString(duration['start'],duration['end'])
      };
      loadAttendance(config);
      setFilterWeek(duration);
    }
    
  const onRowSelect = (data) =>{
    if(data && data.length != 0) {
      setSelectedRow(data)
    } else {
      setSelectedRow([])
    }
  }
  const openDetail = (data) =>{
    const fullName = data?.rowData?.data?.employeeName
    const name = fullName?.split(" ");
    if(name && name[0]) {
      RouteManager.navigateToPage(`${PAGE_ROUTES.TEAM_ATTENDANCE}`,`&name=${name[0]}&selectDate=${selectYear.startDate}`)
    }
  }

  const getFields=(obj)=>{
      return (
        <DKInput
        className={"p-v-s mb-r"}
        icon={obj.icon}
        title={obj.name}
        placeholder={obj.name}
        value={filterPopup?.value ? filterPopup.value : {id:'all',name:"All"} }
        options={obj.options}
        type={obj.type}
        errorMessage={obj.errorMessage}
        labelClassName=" text-align-left "
        onChange={(value) => {
            setFilterPopup({
                ...filterPopup,
                value:value
            })
        }}
        validator={(value) => {
            
        }}
        formatter={(obj) => {
            /** How to render a selected option in case of object **/
            return obj.name;
        }}
        dropdownConfig={{
            className: "",
            style: {},

            data: obj.options,
            renderer: (index, obj) => {
                /** How to render value in Dropdown in case of object **/
                return <DKLabel text={`${obj.name}`} />;
            },
            onSelect: (index, obj) => {

            },
        }}
        direction={obj.direction}
        required={obj.required}
        readOnly={obj.readOnly}
    />
      )
  }
  const getFilterPopup = () =>{
    return (
        <Popup popupClass={'popup-overflow'}>
            <div className="row justify-content-between">
                <DKLabel className="fw-m fs-m" text="Add Filter"/>
                <div className="d-flex">
                    <DKButton className="bg-gray1 border-m" title="Cancel" onClick={()=>{
                        setFilterPopup({
                          ...filterPopup,
                            show:false
                        })
                    }}/>
                    <DKButton className="bg-app text-white ml-m" title="Apply" onClick={()=>{
                        const config = {
                            ...AttendanceService.apiDashboardTeamConfig,
                            status: filterPopup?.value?.id,
                            page: 0
                          };
                          loadAttendance(config,true);
                        setFilterPopup({
                            ...filterPopup,
                            show:false
                        })
                    }}/>
                </div>
            </div>
            {getFields({
            columnCode: "status",
            editable: true,
            hidden: false,
            id: "status",
            index: 2,
            key: "status",
            name: "Status",
            options: [{id:'all',name:"All"},{id:"present",name:"Present"},{id:"absent",name:"Absent"}],
            required: false,
            systemField: true,
            type: INPUT_TYPE.DROPDOWN,
            uiVisible: true,
            width: 200
          })}
        </Popup>
    )
  }
  return (
      <>
        <div className="parent-width"> 
        <div className="row justify-content-between">
            <div className="d-flex align-items-center">
              
              {!isWeekFilterEnable() &&
                <div className="row "> 
                <DKButton
                  className="bg-app text-white  mr-r team-report-date"
                  title={
                    !isMobileWebView() ? selectYear.startDate != ""
                    ? `${Utility.formatDate(
                        moment(selectYear.startDate).format(FORMAT.DDMMYYYY),
                        FORMAT.DDMMYYYY
                      )}`
                    : `${Utility.formatDate(
                        moment().format(FORMAT.DDMMYYYY),
                        FORMAT.DDMMYYYY
                      )}`:""
                  }
                  icon={calender}
                  onClick={(value) => {
                    setYear({
                      toggle: selectYear.toggle ? false : true,
                      startDate: selectYear.startDate,
                      endDate: selectYear.startDate,
                    });
                  }}
                />
                {isPageLoader && <DKSpinner className="mr-m"/>}
                </div> 
                }
                
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              
              <DKSearchBar
                searchText={AttendanceService?.apiDashboardTeamConfig?.searchTerm}
                onSearch={onSearch}
              />
              <DKTooltipWrapper content={"Please enter atleast 3 characters to search"} tooltipClassName="warning-tooltip-prop ">
                    <DKIcon src={DKIcons.ic_info} className="ic-s cursor-hand mr-m" style={{ opacity: 0.4 }}/>
              </DKTooltipWrapper>
              {/* Note: will use Later
              <DKButton
                title=""
                icon={funnel}
                className="bg-app text-white"
                onClick={() => {
                    setFilterPopup({
                        ...filterPopup,
                        show:true
                    })
                }}
              /> */}
              <div
                className="row justify-content-between p-h-r p-v-s border-app border-radius-s position-relative cursor-hand"
                style={{ minWidth: 100 }}
              >
                <div
                  className="parent-height parent-width position-absolute"
                  style={{ top: 0, left: 0, zIndex: 2 }}
                  onClick={(e) => {
                    setFilterPopup({
                      ...filterPopup,
                      show:true
                  })
                  }}
                />
                <DKLabel
                  className="fw-m unselectable text-app"
                  text={filterPopup?.value}
                />
                <DKIcon
                  src={DKIcons.ic_arrow_down2}
                  className="ic-s unselectable"
                />
                {filterPopup.show && (
                  <DKListPicker
                    data={['All','Present','Absent']}
                    className="position-absolute border-m shadow-m parent-width"
                    style={{ top: 36, left: 0, zIndex: 99999 }}
                    onSelect={(index, value) => {
                      const config = {
                        ...AttendanceService.apiDashboardTeamConfig,
                        page: 0,
                        status: value
                      };
                      loadAttendance(config,true);
                      setFilterPopup({
                        ...filterPopup,
                        value:value,
                        show:false
                    })
                    }}
                    onClose={(e) => setFilterPopup({...filterPopup,show:false})}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="">
            {selectYear.toggle && (
              <DKCalendar
                className="position-absolute border-m shadow-m bg-white z-index-3 mt-s"
                isDateRange={false}
                selectedDate={new Date(selectYear.startDate)}
                onSelectDate={(date) => {
                  if (date) {
                    setYear({
                      toggle: false,
                      startDate: date,
                      endDate: date,
                    });
                    const config = {
                      ...AttendanceService.apiDashboardTeamConfig,
                      page: 0,
                      query: getQueryString(date)
                    };
                    loadAttendance(config,true);
                  }
                }}
              />
            )}
          </div>
          <div className="row custom-scroll mt-s parent-width" >
              
            <div className="column parent-width flex-1 parent-height" style={{minHeight:250}}>
              <div className="column parent-width mb-s position-relative flex-1 " ref={gridContainer}>
                <div className={showSpinner?"d-none":""}>
                    <DataGridHolderPayroll
                  tableName={TABLES.PEOPLE_DASHBAORD_TEAM_ATTENDANCE}
                  displayTableName={" "}
                  allowColumnEdit={false}
                  allowColumnDelete={false}
                  allowColumnShift={false}
                  allowSearch={false}
                  allowFilter={false}
                  allowExpand={false}
                  allowRowEdit={false}
                  onRowDelete={onDeleteContact}
                  onRowEdit={(data) => {
                    onRowEdit(data);
                  }}
                  onRowExpand={(data) => {
                    updateRowExpanded(data);
                  }}
                  refresh={refresh}
                  allowRowAdd={false}
                  addButtonConfig={[]}
                  allowDataExport={false}
                  gridData={attendance}
                  onSearch={onSearch}
                  onColumnAdd={newColumnAdded}
                  onFilter={onFilter}
                  filter={attendance.filter}
                  onRowAdd={onRowAdd}
                  onPaginationClick={(requestedPageNumber) => {
                    const config = {
                      ...AttendanceService.apiDashboardTeamConfig,
                      page: requestedPageNumber - 1,
                    };
                    loadAttendance(config,true);
                  }}
                  currentPage={currentPage}
                  totalPageCount={totalPageCount}
                  isActionEnabled={isActionEnabled}
                  isHeaderHidden={true}
                  contextMenu={true}
                  isHideContextMenuWhenRowExpanded={true}
                  onSelection={onRowSelect}
                  gridWidth={gridWidth}
                  allowBulkOperation={false}
                  needTrailingColumn={isMobileWebView()}
                  openDetail={openDetail}
                  allowColumnSort={false}
                  noDataTopHeight={10}
                />
                </div>
                {showSpinner && <div className="row justify-content-center align-item-center parent-height" style={{marginTop: "15%"}}><DKSpinner className="mr-m ic-m"/><DKLabel text="Loading..."/></div>}
              </div>
            </div>
          </div>
        </div>
        {/*Note: Use later
         {filterPopup.show && getFilterPopup()} */}
      </>
    );
}
export default TeamAttendanceCard;